import { RootState } from '../../../stores/store';

export const myDeviseListSelector = (state: RootState) => state.myDeviceList;

export const deviseListSelector = (state: RootState) => state.deviceList;

export const updateDeviseListSelector = (state: RootState) => state.updateListDevices;
